import {getAllProductRequests, isProductRequestChecked} from "../functions";
import {useEffect, useState} from "react";
import Loading from "../../../component/Loading/Loading";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShare} from "@fortawesome/free-solid-svg-icons";
import {PickDateTimeWithoutContainer} from "../../../component/PickDate/PickDate";
import {Modal} from "react-bootstrap";
import Select from "../../../component/Select/Select";
import TextInput from "../../../component/TextInput/TextInput";
import {Button} from "react-bootstrap";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {base64DecodeUnicode, toastError, toastSuccess} from "../../../assets/functions";
import {useNavigate} from "react-router-dom";

const ProductRequests = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allProductRequests, setAllProductRequests] = useState([]);
    const [responseModal, setResponseModal] = useState({
        show: false,
        productRequest: {},
    });

    useEffect(() => {
        (async () => {
            document.title = "درخواست های ثبت شده";
            const allProductRequests = await getAllProductRequests();
            console.log(allProductRequests);
            setAllProductRequests(allProductRequests);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>


    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">درخواست های ثبت شده</h1>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={"table text-center"}>
                                    <thead>
                                    <tr>
                                        <th width={'5%'}>ردیف</th>
                                        <th width={'5%'}>آیدی</th>
                                        <th>نام مشتری</th>
                                        <th>محصول</th>
                                        <th>نوع درخواست</th>
                                        <th width={'20%'}>زمان ثبت درخواست</th>
                                        <th>وضعیت درخواست</th>
                                        <th>پاسخ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        allProductRequests.map((productRequest, index) => {
                                            return (
                                                <tr key={productRequest.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{productRequest.id}</td>
                                                    <td>{(productRequest.customer.person.sex && productRequest.customer.person.sex == "MALE" ? "آقای " : "خانم ") + productRequest.customer.person.firstname + " " + productRequest.customer.person.lastname}</td>
                                                    <td>{productRequest.persianTitle}</td>
                                                    <td>
                                                        {productRequest.request == "PRICE" &&
                                                            <span className={"text-info"}>اطلاع از قیمت</span>}
                                                        {productRequest.request == "BALANCE" && <span
                                                            className={"text-warning"}>اطلاع رسانی موجود شدن</span>}
                                                    </td>
                                                    <td>
                                                        <PickDateTimeWithoutContainer
                                                            timestamp={productRequest.statuses[0].timestamp}
                                                            disabled={true}/>
                                                    </td>
                                                    <td>
                                                        {isProductRequestChecked(productRequest.statuses) &&
                                                            <span className={"text-primary"}>پاسخ داده شده</span>}
                                                        {!isProductRequestChecked(productRequest.statuses) &&
                                                            <span className={"text-danger"}>پاسخ داده نشده</span>}
                                                    </td>
                                                    <td>
                                                        {!isProductRequestChecked(productRequest.statuses) &&
                                                            <button className={"btn btn-secondary"}
                                                                    onClick={() => {
                                                                        setResponseModal({
                                                                            ...responseModal,
                                                                            show: true,
                                                                            productRequest: productRequest
                                                                        })
                                                                    }}
                                                            >
                                                                <FontAwesomeIcon icon={faShare}/>
                                                            </button>}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {responseModal.show && <ResponseModal productRequest={responseModal.productRequest} closeModal={() => {
                setResponseModal({show: false, productRequest: {}});
            }}/>}
        </div>
    );
}

const ResponseModal = ({productRequest, closeModal}) => {
    const navigate = useNavigate()
    const [modalIsOpen, setIsOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const responseOptions = [
        {
            label: "ارسال قیمت",
            value: "SEND_PRICE",
        }, {
            label: "ارسال پیام عدم موجودی",
            value: "OUT_OF_STOCK",
        }
    ];
    const [response, setResponse] = useState({
        type: "SEND_PRICE",
        price: "",
        sendSMS: true,
    })

    const handleSubmit = () => {
        const headers = getManagerHeader();
        setIsLoading(true);
        return axios.post(baseCmsApiUrl + 'productRequests', {productRequestId: productRequest.id, ...response}, {headers})
            .then((response) => {
                toastSuccess(base64DecodeUnicode(response.statusText))
                navigate(0)
                return response.data;
            })
            .catch((e) => {
                console.error(e)
                toastError(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
                setIsLoading(false);
            })
    }

    return (
        <Modal className={"modal-lg"} show={modalIsOpen} onHide={closeModal}>
            <Modal.Header closeButton className={"ltr"}>
                <Modal.Title className={"ms-auto"}>ارسال پاسخ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loading/>}
                {!isLoading && <div className="row">
                    <div className="col-md-6">
                        <Select label={"نوع پاسخ"} options={responseOptions} value={response.type}
                                onChange={(value) => {
                                    setResponse({...response, type: value})
                                }}/>
                    </div>
                    {response.type == "SEND_PRICE" && <div className="col-md-6">
                        <TextInput type={"number"} classname={"mb-3"} label={"قیمت"} value={response.price}
                                   onChange={(value) => {
                                       setResponse({...response, price: value})
                                   }}/>
                    </div>}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <input className="form-check-input" type="checkbox" value="" id="sendSMS"
                                       checked={response.sendSMS} onChange={() => {
                                    setResponse({...response, sendSMS: !response.sendSMS})
                                }}/>
                                <label className="form-check-label me-2" htmlFor="sendSMS">
                                    اس ام اس اطلاع رسانی به کاربر ارسال شود.
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    بستن
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    ارسال
                </Button>
            </Modal.Footer>
        </Modal>
    )
}


export default ProductRequests;